import React from 'react';
import AdminPage from 'presentation/pages/admin/AdminPage';
import { useClearReportOnNavigation } from '../../../../hooks/useClearReportOnNavigation';

function AdminViewFactory() {
  useClearReportOnNavigation();

  return <AdminPage />;
}

export default AdminViewFactory;
